<div class="service-summary" [class.service-summary--force-column]="forceTrafficBottom()">
  <div class="service-summary__main">
    <div class="service-summary__header">
      <service-title-block
        [healthStatus]="health().status"
        [isAccessible]="isAccessible()"
        [service]="service()"
        [tags]="tags()"
        [title]="title()"
      />
    </div>
    <div class="service-summary__table">
      <div class="service-summary__table-row">
        <div class="service-summary__table-col">{{ "ServiceElement.Owner" | translate }}</div>
        <div class="service-summary__table-col">{{ organisationName() }}</div>
      </div>
      <div class="service-summary__table-row">
        <div class="service-summary__table-col">{{ "ServiceElement.ServiceID" | translate }}</div>
        <div class="service-summary__table-col">{{ subscriptionId() | shorten_guid }}</div>
      </div>
    </div>
    <div class="service-summary__bottom">
      <div class="button button--secondary service-summary__scroll-button" (click)="navigateToChart()">
        {{ "Global.ShowTraffic" | translate }}
      </div>
    </div>
  </div>
  <traffic-speed [showTraffic]="showTraffic()" [health]="health()" />
</div>
